/* eslint-disable */
/**
 * Comparación V/S entre jaulas y métricas seleccionadas.
 *
 * Estos métodos operan sobre la instancia de PanelLogic y conservan el
 * contrato del prototipo importado. No mantienen estado global propio.
 */
const logic = {
  vsSel(st) {
    return (st.vsSel || this.data.cages.map((_, i) => i).slice(0, 4)).slice(0, 4);
  },
  get vsPal() {
    return ['oklch(0.68 0.15 262)', 'oklch(0.78 0.14 70)', 'oklch(0.68 0.17 305)', 'oklch(0.75 0.11 185)'];
  },
  vsVals(st) {
    const D = this.data,
      N = D.days.length,
      pal = this.vsPal,
      sel = this.vsSel(st),
      per = st.vsPer || 'all',
      n = sel.length;
    const start = per === 'all' ? 0 : Math.max(0, N - per),
      days = [];
    for (let d = start; d < N; d++) days.push(d);
    const nD = days.length;
    // SCAPP already returns delivered_food in tonnes. Keep the backend value as-is
    // so small daily values are not converted a second time and rounded to 0.0.
    const kgD = c => c.ay || !Number.isFinite(c.kg) ? 0 : c.kg;
    const MET = {
      kg: {
        l: 'Alimento entregado',
        s: 'Alimento',
        u: 'ton',
        c: 'oklch(0.74 0.12 230)',
        v: kgD,
        avg: false,
        f: v => v.toFixed(1) + ' ton',
        fd: v => v.toFixed(2) + ' ton'
      },
      sfr: {
        l: 'SFR promedio',
        s: 'SFR',
        u: '%',
        c: 'oklch(0.7 0.17 45)',
        v: c => c.ay || !Number.isFinite(c.sfr) ? null : c.sfr,
        avg: true,
        f: v => v.toFixed(1) + ' %',
        fd: v => v + ' %'
      },
      al: {
        l: 'Alarmas',
        s: 'Alarmas',
        c: 'oklch(0.8 0.13 85)',
        v: c => c.al,
        f: v => String(Math.round(v)),
        fd: v => String(v)
      },
      ppa: {
        l: 'Pellets perdidos',
        s: 'PPA',
        c: 'oklch(0.66 0.19 25)',
        v: c => c.ppa,
        f: v => String(Math.round(v)),
        fd: v => String(v)
      },
      vis: {
        l: 'Visitas',
        s: 'Visitas',
        c: 'oklch(0.76 0.14 155)',
        v: c => c.vis,
        f: v => String(Math.round(v)),
        fd: v => String(v)
      }
    };
    const keys = Object.keys(MET),
      on = st.vsMets || keys,
      act = keys.filter(k => on.includes(k));
    const agg = (ci, k) => {
      const vs = days.map(d => MET[k].v(D.rows[ci].cells[d])).filter(v => v != null);
      if (!vs.length) return 0;
      const s = vs.reduce((a, b) => a + b, 0);
      return MET[k].avg ? s / vs.length : s;
    };
    const A = sel.map(ci => {
        const o = {};
        keys.forEach(k => o[k] = agg(ci, k));
        return o;
      }),
      mx = {};
    keys.forEach(k => mx[k] = Math.max(1e-9, ...A.map(a => a[k])));
    const hv = st.vsHov || null,
      hd = hv && hv.d != null && days.includes(hv.d) ? hv.d : null,
      hi = hv && hv.i != null ? hv.i : null;
    const fS = v => v >= 100 ? String(Math.round(v)) : v >= 10 ? v.toFixed(0) : v.toFixed(1);
    const TN = (c, a) => c.replace(')', ' / ' + a + ')'),
      kSh = st.vsChartK || 'sfr';
    const mkSlot = (ci, i) => {
      const k = kSh,
        m = MET[k],
        vals = days.map(d => {
          const c = D.rows[ci].cells[d];
          return c.ay ? null : m.v(c);
        });
      const top = Math.max(k === 'sfr' ? 110 : 1e-9, ...vals.filter(v => v != null)),
        Y = v => 100 - v / top * 94,
        bw = 600 / nD;
      let p = '',
        pa = '';
      vals.forEach((v, j) => {
        const x = (j * bw + bw * 0.16).toFixed(1),
          w = (bw * 0.68).toFixed(1);
        if (v == null) {
          pa += 'M' + x + ' 97h' + w + 'v3h-' + w + 'Z';
          return;
        }
        p += 'M' + x + ' 100V' + Y(v).toFixed(1) + 'h' + w + 'V100Z';
      });
      const step = Math.ceil(nD / 7),
        jd = hd == null ? -1 : days.indexOf(hd),
        hvV = jd < 0 ? null : vals[jd];
      const hb = jd < 0 || hvV == null ? 'M0 0' : 'M' + (jd * bw + bw * 0.16).toFixed(1) + ' 100V' + Y(hvV).toFixed(1) + 'h' + (bw * 0.68).toFixed(1) + 'V100Z';
      const tipV = hvV == null ? 'Ayuno' : m.fd(+hvV.toFixed(k === 'kg' ? 2 : 0));
      return {
        first: i === 0,
        hits: days.map(d => ({
          enter: () => this.setState({
            vsHov: {
              i,
              d
            }
          })
        })),
        leave: () => this.setState({
          vsHov: null
        }),
        hb,
        cur: jd >= 0,
        curL: ((jd + 0.5) / nD * 100).toFixed(2) + '%',
        tip: (jd >= 0 ? D.days[hd] : '') + ' · ' + tipV,
        tipTx: jd / nD > 0.6 ? "translate(calc(-100% - 0.416667vw),0)" : "translate(0.416667vw,0)",
        cardOp: hi != null && hi !== i && hd == null ? 0.55 : 1,
        ol: hi === i ? pal[i] : 'transparent',
        key: i + '-' + ci + '-' + k,
        ci: String(ci),
        name: D.cages[ci],
        c: pal[i],
        bars: p || 'M0 0',
        ay: pa || 'M0 0',
        chart: k,
        title: m.l + (m.u ? ' [' + m.u + (k === 'kg' ? '/día' : '') + ']' : ' por día'),
        showRef: k === 'sfr',
        ref: k === 'sfr' ? 'M0 ' + Y(100).toFixed(2) + ' H600' : 'M0 0',
        refTop: Y(100).toFixed(2) + '%',
        yt: [0, 0.5, 1].map(f => ({
          lab: fS(top * f),
          top: Y(top * f).toFixed(2) + '%'
        })),
        xt: days.map((d, j) => ({
          d,
          j
        })).filter(o => o.j % step === 0).map(o => ({
          lab: D.days[o.d],
          left: ((o.j + 0.5) / nD * 100).toFixed(2) + '%'
        })),
        sumL: m.avg ? 'Promedio' : 'Total',
        sum: m.f(A[i][k]),
        cageOpts: D.cages.map((nm, x) => ({
          v: String(x),
          l: nm,
          sel: x === ci
        })),
        chartOpts: keys.map(x => ({
          v: x,
          l: MET[x].l,
          sel: x === k
        })),
        onCage: e => {
          const v = +e.target.value;
          this.setState(s => {
            const a = this.vsSel(s);
            const j = a.indexOf(v);
            if (j >= 0) a[j] = a[i];
            a[i] = v;
            return {
              vsSel: a,
              vsHov: null
            };
          });
        }
      };
    };
    const slots = sel.map(mkSlot);
    const vsChartPills = keys.map(x => {
      const o = x === kSh;
      return {
        l: MET[x].s,
        title: 'Ver ' + MET[x].l + ' en todas las tarjetas',
        c: MET[x].c,
        bg: o ? TN(MET[x].c, 0.18) : 'transparent',
        bd: o ? MET[x].c : 'rgba(135,147,166,0.22)',
        color: o ? '#e4e9f0' : '#8793a6',
        fw: o ? 600 : 400,
        onClick: () => this.setState({
          vsChartK: x
        })
      };
    });
    const R = 200,
      P = (a, r) => {
        const t = a * Math.PI / 180;
        return (r * Math.cos(t)).toFixed(1) + ' ' + (r * Math.sin(t)).toFixed(1);
      },
      XY = (a, r) => {
        const t = a * Math.PI / 180;
        return [r * Math.cos(t), r * Math.sin(t)];
      };
    const valOf = (i, k) => hd == null ? A[i][k] : MET[k].v(D.rows[sel[i]].cells[hd]) || 0,
      MX = {};
    keys.forEach(k => MX[k] = Math.max(1e-9, ...sel.map((_, i) => valOf(i, k))));
    const fmtV = (i, k) => hd == null ? MET[k].f(A[i][k]) : D.rows[sel[i]].cells[hd].ay ? '–' : MET[k].fd(+valOf(i, k).toFixed(k === 'kg' ? 2 : 0));
    const span = 360 / n,
      tab = st.vsTab || 'area',
      radarDaily = tab === 'radar' && !!st.vsRadarDaily,
      radarMetric = keys.includes(st.vsRadarMetric) ? st.vsRadarMetric : act[0] || keys[0],
      shownAct = radarDaily ? [radarMetric] : act,
      PC = (x, y, an) => ({
        L: ((x + 300) / 6).toFixed(2) + '%',
        T: ((y + 275) / 5.5).toFixed(2) + '%',
        tx: an === 'start' ? 'translate(0,-50%)' : an === 'end' ? 'translate(-100%,-50%)' : 'translate(-50%,-50%)'
      });
    const arc = (b0, b1, r) => 'M' + P(b0, r) + ' A' + r + ' ' + r + ' 0 ' + (b1 - b0 > 180 ? 1 : 0) + ' 1 ' + P(b1, r);
    const rimR = tab === 'adv' ? 238 : R + 12;
    const vsRims = sel.map((ci, i) => {
      const a0 = -90 + i * span,
        mid = a0 + span / 2,
        [x, y] = XY(mid, rimR + 18),
        [lx, ly] = XY(mid, rimR + 16);
      return {
        d: arc(a0 + 1.5, a0 + span - 1.5, rimR),
        c: pal[i],
        n: D.cages[ci],
        lx: lx.toFixed(1),
        ly: ly.toFixed(1),
        ...PC(lx, Math.max(-262, Math.min(262, ly)), x > 20 ? 'start' : x < -20 ? 'end' : 'middle')
      };
    });
    let out = {
      vsLeft: slots.filter((_, i) => i % 2 === 0),
      vsRight: slots.filter((_, i) => i % 2 === 1),
      vsRims,
      vsTHead: keys.map(k => {
        const o = shownAct.includes(k);
        return {
          key: k,
          on: o,
          l: MET[k].l,
          title: radarDaily ? 'Ver ' + MET[k].l.toLowerCase() + ' por día' : (o ? 'Quitar ' : 'Incluir ') + MET[k].l.toLowerCase() + ' en los gráficos',
          c: o ? '#e4e9f0' : '#5a667a',
          dc: o ? MET[k].c : '#3a4558',
          dot: o ? MET[k].c : 'transparent',
          tick: o ? '✓' : '',
          bd: o ? MET[k].c : 'rgba(46,179,238,0.1)',
          bg: o ? TN(MET[k].c, 0.07) : 'transparent',
          onClick: radarDaily ? () => this.setState({
            vsRadarMetric: k,
            vsHov: null
          }) : () => this.setState(s => {
              const cur = s.vsMets || keys;
              const nx = cur.includes(k) ? cur.filter(x => x !== k) : [...cur, k];
              return {
                vsMets: nx.length ? nx : cur,
                vsHov: null
              };
            })
        };
      }),
      vsTFirst: hd == null ? 'Jaula' : 'Día ' + D.days[hd],
      vsTFirstC: hd == null ? '#8793a6' : 'oklch(0.72 0.17 45)',
      vsTable: sel.map((ci, i) => {
        const bg = hi === i ? 'rgba(46,179,238,0.12)' : 'transparent',
          enter = () => this.setState(s => ({
            vsHov: {
              i,
              d: s.vsHov && s.vsHov.d != null && s.vsHov.i === i ? s.vsHov.d : null
            }
          }));
        return {
          n: D.cages[ci],
          c: pal[i],
          bg,
          enter,
          cells: keys.map(k => ({
            v: fmtV(i, k),
            c: shownAct.includes(k) ? MET[k].c : '#3a4558',
            bg,
            enter
          }))
        };
      }),
      vsChartPills,
      vsMetCount: sel.length + ' jaulas · ' + shownAct.length + ' de ' + keys.length + ' métricas',
      vsShowMetAll: !radarDaily,
      vsMetAll: () => this.setState({
        vsMets: null,
        vsHov: null
      }),
      vsMetAllOp: act.length === keys.length ? 0.35 : 1,
      vsMetBtns: keys.map(k => {
        const o = shownAct.includes(k);
        return {
          l: MET[k].l,
          c: MET[k].c,
          dot: o ? MET[k].c : 'transparent',
          bg: o ? TN(MET[k].c, 0.14) : 'transparent',
          bd: o ? TN(MET[k].c, 0.7) : 'rgba(135,147,166,0.22)',
          color: o ? '#e4e9f0' : '#6b778a',
          fw: o ? 600 : 400,
          onClick: radarDaily ? () => this.setState({
            vsRadarMetric: k,
            vsHov: null
          }) : () => this.setState(s => {
              const cur = s.vsMets || keys;
              const nx = cur.includes(k) ? cur.filter(x => x !== k) : [...cur, k];
              return {
                vsMets: nx.length ? nx : cur,
                vsHov: null
              };
            })
        };
      }),
      vsPers: [[7, '7 d'], [14, '14 d'], [30, '30 d'], ['all', 'Todo']].map(([k, label]) => ({
        label,
        bg: per === k ? 'rgba(46,179,238,0.16)' : 'transparent',
        color: per === k ? '#e4e9f0' : '#8793a6',
        onClick: () => this.setState({
          vsPer: k,
          vsHov: null
        })
      })),
      vsTabs: [['area', 'Área'], ['radar', 'Radar'], ['adv', 'Avanzado']].map(([k, label]) => ({
        label,
        color: tab === k ? '#e4e9f0' : '#5a667a',
        bd: tab === k ? 'oklch(0.66 0.19 42)' : 'transparent',
        onClick: () => this.setState({
          vsTab: k,
          vsHov: null
        })
      })),
      vsRadarToggle: tab === 'radar' ? {
        label: radarDaily ? 'Ver todas las métricas' : 'Ver por días',
        pressed: radarDaily,
        onClick: () => this.setState({
          vsRadarDaily: !radarDaily,
          vsRadarMetric: radarMetric,
          vsHov: null
        })
      } : null,
      vsIsArea: tab === 'area',
      vsIsRadar: tab === 'radar' && (radarDaily || act.length >= 3),
      vsRadarMsg: tab === 'radar' && !radarDaily && act.length < 3,
      vsIsAdv: tab === 'adv',
      vsTipHeight: tab === 'adv' ? (4.62963 + n * 2.777778) + 'vh' : '5.37037vh',
      vsLeave: () => this.setState({
        vsHov: null
      }),
      vsInfo: '',
      vsFoot: ''
    };
    const dayTag = hd == null ? '' : 'Día ' + D.days[hd] + ' · ';
    const D0 = D.days[days[0]],
      D1 = D.days[days[nD - 1]];
    const tipFor = (i, x, y, kH) => {
      const right = x <= 0;
      return {
        on: true,
        L: ((x + 300) / 6).toFixed(2) + '%',
        T: ((y + 275) / 5.5).toFixed(2) + '%',
        tx: (right ? "translate(0.729167vw," : "translate(calc(-100% - 0.729167vw),") + (y < -120 ? '0' : y > 120 ? '-100%' : '-50%') + ')',
        title: D.cages[sel[i]],
        c: pal[i],
        sub: hd == null ? D0 + ' – ' + D1 : 'Día ' + D.days[hd],
        rows: shownAct.map(k => ({
          l: MET[k].s,
          c: MET[k].c,
          v: fmtV(i, k),
          w: Math.round(valOf(i, k) / MX[k] * 100) + '%',
          fw: kH === k ? 700 : 500,
          bg: kH === k ? 'rgba(46,179,238,0.1)' : 'transparent'
        }))
      };
    };
    let vsTip = {
      on: false,
      rows: []
    };
    if (tab === 'area') {
      const hA = hv,
        mA = Math.max(1, act.length),
        W = [];
      sel.forEach((ci, i) => {
        const a0 = -90 + i * span,
          w = (span - 8) / mA;
        act.forEach((k, j) => {
          const b0 = a0 + 4 + j * w,
            b1 = b0 + w - 1,
            r = R * (0.1 + 0.9 * valOf(i, k) / MX[k]),
            o = hi === i && (!hA.k || hA.k === k);
          if (hi === i && (!hA.k || hA.k === k)) {
            const [tx0, ty0] = XY((b0 + b1) / 2, Math.max(r * 0.7, 40));
            vsTip = tipFor(i, tx0, ty0);
          }
          W.push({
            d: 'M0 0 L' + P(b0, r) + ' A' + r.toFixed(1) + ' ' + r.toFixed(1) + ' 0 0 1 ' + P(b1, r) + ' Z',
            fill: MET[k].c,
            op: hi != null ? o ? 0.95 : 0.28 : 0.72,
            enter: () => this.setState(s => ({
              vsHov: {
                i,
                k,
                d: hd
              }
            }))
          });
        });
      });
      out = {
        ...out,
        vsWedges: W,
        vsGrid: [0.25, 0.5, 0.75, 1].map(f => ({
          r: (R * f).toFixed(1)
        })),
        vsTip,
        vsInfo: hi != null && hA.k ? dayTag + D.cages[sel[hi]] + ' · ' + MET[hA.k].l + ': ' + fmtV(hi, hA.k) + ' (' + Math.round(valOf(hi, hA.k) / MX[hA.k] * 100) + ' % del mayor)' : hi != null ? dayTag + D.cages[sel[hi]] + ' · ' + act.map(k => MET[k].s + ' ' + fmtV(hi, k)).join(' · ') : hd != null ? dayTag + 'valores del día' : 'Cada sector es una jaula; cada cuña, una métrica · largo relativo a la jaula con el mayor valor · ' + D0 + ' – ' + D1
      };
    }
    if (tab === 'radar' && radarDaily) {
      const m = days.length,
        hR = hi,
        ang = j => -90 + j * 360 / Math.max(1, m),
        dailyValue = (i, j) => {
          const value = MET[radarMetric].v(D.rows[sel[i]].cells[days[j]]);
          return Number.isFinite(value) ? Math.max(0, value) : 0;
        },
        dailyMax = Math.max(1e-9, ...sel.flatMap((_, i) => days.map((__, j) => dailyValue(i, j))));
      out = {
        ...out,
        vsRGrid: [0.25, 0.5, 0.75, 1].map(f => ({
          d: 'M' + days.map((_, j) => P(ang(j), R * f)).join(' L') + ' Z'
        })),
        vsAxes: days.map((d, j) => {
          const [x] = XY(ang(j), R),
            [lx, ly] = XY(ang(j), R + 24);
          return {
            d: 'M0 0 L' + P(ang(j), R),
            lx: lx.toFixed(1),
            ly: ly.toFixed(1),
            ...PC(lx, ly, x > 20 ? 'start' : x < -20 ? 'end' : 'middle'),
            l: D.days[d],
            c: MET[radarMetric].c
          };
        }),
        vsPolys: sel.map((ci, i) => {
          const pts = days.map((d, j) => XY(ang(j), R * dailyValue(i, j) / dailyMax)),
            hoveredDay = hd == null ? -1 : days.indexOf(hd);
          if (hR === i) {
            const point = hoveredDay >= 0 ? pts[hoveredDay] : pts.reduce((best, candidate) => candidate[0] ** 2 + candidate[1] ** 2 > best[0] ** 2 + best[1] ** 2 ? candidate : best);
            vsTip = tipFor(i, point[0], point[1], radarMetric);
          }
          return {
            d: 'M' + pts.map(point => point[0].toFixed(1) + ' ' + point[1].toFixed(1)).join(' L') + ' Z',
            c: pal[i],
            fo: hR == null ? 0.1 : hR === i ? 0.28 : 0.03,
            so: hR == null || hR === i ? 1 : 0.2,
            enter: () => this.setState({
              vsHov: {
                i,
                d: hd
              }
            }),
            dots: pts.map((point, j) => ({
              x: point[0].toFixed(1),
              y: point[1].toFixed(1),
              day: D.days[days[j]],
              value: dailyValue(i, j),
              enter: () => this.setState({
                vsHov: {
                  i,
                  d: days[j]
                }
              })
            }))
          };
        }),
        vsTip: null,
        vsInfo: hd != null && hR != null ? 'Día ' + D.days[hd] + ' · ' + D.cages[sel[hR]] + ' · ' + MET[radarMetric].s + ' ' + fmtV(hR, radarMetric) : 'Cada eje es un día · una sola métrica: ' + MET[radarMetric].l,
        vsFoot: 'Evolución diaria de ' + MET[radarMetric].l + ' · cada polígono representa una jaula'
      };
      out.vsTip = vsTip;
    }
    if (tab === 'radar' && !radarDaily && act.length >= 3) {
      const m = act.length,
        hR = hi,
        ang = j => -90 + j * 360 / m;
      out = {
        ...out,
        vsRGrid: [0.25, 0.5, 0.75, 1].map(f => ({
          d: 'M' + act.map((_, j) => P(ang(j), R * f)).join(' L') + ' Z'
        })),
        vsAxes: act.map((k, j) => {
          const [x] = XY(ang(j), R),
            [lx, ly] = XY(ang(j), R + 24);
          return {
            d: 'M0 0 L' + P(ang(j), R),
            lx: lx.toFixed(1),
            ly: ly.toFixed(1),
            ...PC(lx, ly, x > 20 ? 'start' : x < -20 ? 'end' : 'middle'),
            l: MET[k].l,
            c: MET[k].c
          };
        }),
        vsPolys: sel.map((ci, i) => {
          const pts = act.map((k, j) => XY(ang(j), R * (0.06 + 0.94 * valOf(i, k) / MX[k])));
          if (hR === i) {
            const pk = pts.reduce((b, p) => p[0] ** 2 + p[1] ** 2 > b[0] ** 2 + b[1] ** 2 ? p : b);
            vsTip = tipFor(i, pk[0], pk[1]);
          }
          return {
            d: 'M' + pts.map(p => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' L') + ' Z',
            c: pal[i],
            fo: hR == null ? 0.1 : hR === i ? 0.28 : 0.03,
            so: hR == null || hR === i ? 1 : 0.2,
            enter: () => this.setState({
              vsHov: {
                i,
                d: hd
              }
            }),
            dots: pts.map(p => ({
              x: p[0].toFixed(1),
              y: p[1].toFixed(1)
            }))
          };
        }),
        vsTip: null,
        vsInfo: hR != null ? dayTag + D.cages[sel[hR]] + ' · ' + act.map(k => MET[k].s + ' ' + fmtV(hR, k)).join(' · ') : hd != null ? dayTag + 'valores del día' : 'Cada eje se escala a la jaula con el mayor valor · Alarmas y PPA: más afuera = peor',
        vsFoot: ''
      };
      out.vsTip = vsTip;
    }
    if (tab === 'adv') {
      const ring = act.filter(k => k !== 'sfr'),
        showS = act.includes('sfr'),
        r1 = 222,
        r0 = ring.length > 2 ? 120 : 150,
        stp = ring.length > 1 ? (r1 - r0) / (ring.length - 1) : 0,
        coreR = 92;
      const dmx = {};
      ring.forEach(k => {
        let m = 1e-9;
        sel.forEach(ci => days.forEach(d => {
          const v = MET[k].v(D.rows[ci].cells[d]) || 0;
          if (v > m) m = v;
        }));
        dmx[k] = m;
      });
      const dots = [],
        hits = [],
        bars = [];
      let hovLine = 'M0 0';
      sel.forEach((ci, i) => {
        const a0 = -90 + i * span + 4,
          sp = span - 8,
          aw = sp / nD;
        let bp = '';
        days.forEach((d, j) => {
          const c = D.rows[ci].cells[d],
            a = a0 + (j + 0.5) * aw,
            isD = hd === d,
            isH = isD && hi === i;
          ring.forEach((k, q) => {
            const v = c.ay ? 0 : MET[k].v(c) || 0;
            if (!v) return;
            const rr = r1 - q * stp,
              [x, y] = XY(a, rr),
              dm = Math.max(1.6, Math.min(6.5, rr * aw * Math.PI / 180 * 0.6, stp ? stp * 0.42 : 7));
            dots.push({
              x: x.toFixed(1),
              y: y.toFixed(1),
              r: (0.9 + Math.sqrt(v / dmx[k]) * dm).toFixed(2),
              f: MET[k].c,
              op: hd != null ? isD ? 1 : 0.14 : hi != null ? hi === i ? 0.9 : 0.2 : 0.8,
              s: isH ? '#fff' : 'none'
            });
          });
          if (showS && !c.ay) {
            const b0 = coreR + 8,
              b1 = b0 + Math.min(1.5, c.sfr / 100) * 16;
            bp += 'M' + P(a, b0) + ' L' + P(a, b1) + ' ';
          }
          const h0 = a - aw / 2,
            h1 = a + aw / 2;
          hits.push({
            d: 'M' + P(h0, coreR) + ' L' + P(h0, 246) + ' A246 246 0 0 1 ' + P(h1, 246) + ' L' + P(h1, coreR) + ' A' + coreR + ' ' + coreR + ' 0 0 0 ' + P(h0, coreR) + ' Z',
            enter: () => this.setState({
              vsHov: {
                i,
                d
              }
            })
          });
          if (isD) hovLine = (hovLine === 'M0 0' ? '' : hovLine + ' ') + 'M' + P(a, coreR) + ' L' + P(a, 236);
        });
        if (bp) bars.push({
          d: bp,
          c: pal[i]
        });
      });
      let core;
      if (hd != null) {
        // Compare every selected cage on the hovered date, using the same
        // metric definitions and formatting as the radar tooltip.
        vsTip = {
          on: true,
          title: 'Día ' + D.days[hd],
          c: 'oklch(0.74 0.12 230)',
          sub: n + ' jaulas',
          rows: tipFor(0, 0, 0).rows,
          groups: sel.map((_, i) => ({
            ...tipFor(i, 0, 0),
            active: hi === i
          }))
        };
        core = [{
          t: 'Día ' + D.days[hd],
          c: 'oklch(0.72 0.17 45)',
          s: 15,
          w: 600,
          mt: '0'
        }, {
          t: n + ' jaulas',
          c: '#8793a6',
          s: 12,
          w: 400,
          mt: '0'
        }];
      } else core = [{
        t: 'Pasa el mouse',
        c: '#8793a6',
        s: 13,
        w: 500,
        mt: '0'
      }, {
        t: 'sobre un día',
        c: '#8793a6',
        s: 13,
        w: 500,
        mt: '0'
      }];
      out = {
        ...out,
        vsDots: dots,
        vsHits: hits,
        vsSfrBars: bars,
        vsHovLine: hovLine,
        vsCore: core,
        vsCoreR: String(coreR),
        vsGuides: ring.map((k, q) => ({
          r: (r1 - q * stp).toFixed(1)
        })),
        vsInfo: 'Cada cuadrante es una jaula y avanza día a día en sentido horario (' + D0 + ' → ' + D1 + ')',
        vsFoot: 'Anillos de afuera hacia adentro: ' + ring.map(k => MET[k].s).join(' · ') + (showS ? ' · barras internas = SFR' : '') + ' · tamaño del punto = valor del día'
      };
    }
    if (!out.vsTip) out.vsTip = vsTip;
    out.vsNoTip = !(out.vsTip && out.vsTip.on);
    out.vsTipN = String(out.vsTip && out.vsTip.rows ? out.vsTip.rows.length : 5);
    return out;
  }
};
export default logic;
